'use client'

import React, { useMemo } from 'react'
import { useLocale, useTranslations } from 'next-intl'
import { TopAirlines } from './topAirlines'
import { Airline } from '@/src/api/requests/topAirlines'

interface TopAirlinesWrapperProps {
    topAirlines?: Airline[]
}

export const TopAirlinesWrapper: React.FC<TopAirlinesWrapperProps> = ({ topAirlines }) => {
    const t = useTranslations('homePage.headings')
    const locale = useLocale()
    const isArabic = locale === 'ar'

    const airlines = useMemo(
        () => {
            if (!topAirlines) return []
            return topAirlines.map(airline => ({
                ...airline,
                name: isArabic ? airline.name_ar || airline.name_en : airline.name_en,
                href: isArabic ? airline.href_ar || airline.href_en : airline.href_en
            }))
        },
        [topAirlines, isArabic]
    )

    if (!topAirlines || topAirlines.length === 0) {
        return null
    }

    return <TopAirlines title={t('topAirlines')} airlines={airlines} locale={locale}/>
}

export default TopAirlinesWrapper